<template>
  <div class="warpper">
    <!-- 搜索筛选 -->
    <div v-if="!edit" class="top">
      <div class="_op">
        <el-select v-model="formData.type" placeholder="药品类别">
          <el-option
            v-for="(item, index) in drugTypeList"
            :key="index"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
        <span></span>
      </div>
      <div class="keyword">
        <el-input
          v-model="formData.name"
          placeholder="请输入搜索内容"
          @keyup.enter.native="searchList()"
          clearable
        ></el-input>
      </div>
      <div class="btn">
        <el-button type="primary" @click="searchList()">搜索</el-button>
        <el-button type="primary" @click="emptyList()">重置</el-button>
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <!-- 药品列表 -->
      <div v-if="!edit && dataList.length > 0" class="left">
        <div class="drug-item" v-for="(item, index) in dataList" :key="index">
          <div class="_item-title">
            <el-radio
              :label="index"
              v-model="drugRadio"
              @change="changeDurgFrom(item, index)"
              >{{ item.name }}
              <span class="approval_number">{{ item.companyName }}</span>
            </el-radio>
          </div>
        </div>
        <div class="left_foo">
          <el-pagination
            small
            @current-change="handleCurrentChange"
            :page-size="formData.pageSize"
            :current-page="formData.currentPage"
            layout="total, prev, pager, next"
            :total="totalCount"
          ></el-pagination>
        </div>
      </div>
      <!-- 空数据 -->
      <div
        v-if="!edit && !formShow && dataList.length < 1"
        class="emptyDataCenter"
      >
        <emptyData></emptyData>
      </div>
      <!-- 选中药品form表单 -->
      <drugForm
        v-if="formShow"
        :drugItem="drugItem"
        :formShow="formShow"
        :drugNumSpcesObjAll="drugNumSpcesObjAll"
        @on-drug-add="onDrugAdd"
      ></drugForm>
    </div>
  </div>
</template>
<script type="text/javascript">
import { getDrugList } from "@/api";
import emptyData from "@/components/common/emptyData";
import drugForm from "./form.vue";

export default {
  name: "DrugPanel", // 搜索药品
  components: {
    emptyData,
    drugForm,
  },
  props: {
    drugNumSpcesObjAll: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formShow: false, // form隐藏
      edit: false, // 0为新增，1为编辑
      totalCount: 0, // 总页数
      formData: {
        currentPage: 1,
        pageSize: 10,
        type: 0,
        name: "",
      }, // 接口所需参数
      dataList: {}, // 接口返回参数
      drugTypeList: [
        // 药品类型
        { title: "全部", id: 0 },
        { title: "西药", id: 1 },
        { title: "中成药", id: 2 },
      ],
      drugItem: null, //选中药品
      drugRadio: null,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      // 获取数据
      const params = {
        currentPage: this.formData.currentPage,
        pageSize:  this.formData.pageSize,
        type:  this.formData.type ? this.formData.type: null ,
        name: this.formData.name.trim(),
      }
      let res = await getDrugList(params);
      if (res.code == 1) {
        this.dataList = res.data.records;
        this.totalCount = Number(res.data.totalCount);
      }
    },
    searchList() {
      this.formData.currentPage = 1;
      this.formShow = false; // 隐藏from数据
      this.getList();
    },
    //分页
    handleCurrentChange(e) {
      this.formData.currentPage = e;
      this.getList();
    },
    emptyList() {},
    // 选中该药品
    changeDurgFrom(item, index) {
      if (item.isPoison || item.isNarcotic || item.isSpirit || item.isAntibiotic) {
        this.$message({
          message: "根据相关规定要求，互联网医院禁止开具药品类易制毒化学品，麻醉类、精神类药品、注射类药品和特殊使用级抗生素",
          type: "warning",
        });
        this.formShow = false;
        return;
      }
      if (item.isRisk || item.warnA || item.warnB || item.warnC) {
        this.$message({
          message: "注意！您正在开具含有高警示类药品的处方，请您谨慎核对所开处方药品是否符合病情需要",
          type: "warning",
        });
      }

      this.formShow = true;
      if(item.packUnit)item.drugNumUnit=item.packUnit;
      this.drugItem = item;
    },
    onDrugAdd(item) {
      //添加处方
      this.$emit("on-drug-add", item);
    },
    //编辑回填数据
    async initDetail(item) {
      this.edit = true;
      this.formShow = true;
      this.drugItem = item;
    },
  },
};
</script>
<style lang="scss" type="text/css">
.warpper {
  min-height: 570px;
  .top {
    display: flex;
    width: 75%;
    color: #999999;
    ._op {
      flex: 0 0 20%;
      display: flex;
      align-items: center;
    }
    .keyword {
      flex: 1;
      display: flex;
      align-items: center;
      margin-right: 10px;
    }
  }

  .content {
    display: flex;
    margin: 20px 0 0 0;
    .left {
      flex: 0 0 50%;
      border-right: 1px solid #999999;
      margin-right: 5px;
      .drug-item {
        background: #fafafa;
        margin: 10px 20px 0 0;
        ._item-title {
          display: flex;
          align-items: center;
          padding: 10px 20px;
          .approval_number {
            position: absolute;
            left: 280px;
          }
        }
      }
      .left_foo {
        margin-top: 15px;
        text-align: center;
        font-size: 22px;
      }
    }
  }
  .emptyDataCenter {
    min-height: 500px;
    margin: 0 auto;
    align-items: center;
  }
}
</style>